import axios from 'axios';

// Create axios instance with custom config
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add a request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a global variable to store session expiration message
window.__SESSION_EXPIRED__ = false;

// Add a response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      const errorType = error.response?.data?.error;
      
      // Clear token and user data
      localStorage.removeItem('token');
      delete axios.defaults.headers.common['Authorization'];
      
      // Set session expired flag for user notification
      if (errorType === 'TOKEN_EXPIRED') {
        window.__SESSION_EXPIRED__ = true;
      }
      
      // Only redirect if not already on login page
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api; 